import {FC, useState, useEffect, Fragment} from 'react'

import {Col, Form, Modal, Row} from 'react-bootstrap'

import Api from '../../../thesis-and-dissertations/helpers/api'
import handleApiError from 'thesis-and-dissertations/helpers/handleApiError'
import {toast} from 'react-toastify'
import {useNavigate} from 'react-router-dom'
const api = new Api()

type Props = {
  showModalUpload: boolean
  handleShowModalUpload: any
  typeUpload: string
  priority: number
}

const UploadContent: FC<Props> = ({
  showModalUpload,
  handleShowModalUpload,
  typeUpload,
  priority,
}) => {
  const navigate = useNavigate()
  const [showModal, setShowModal] = useState(false)
  const [file, setFile] = useState<any>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const [errors, setErrors] = useState<any>({})

  useEffect(() => {
    setShowModal(showModalUpload)
  }, [showModalUpload])

  const handleCloseModal = () => {
    setShowModal(false)
    setFile(null)
    handleShowModalUpload(false)
    setErrors({})
  }

  const handleChangeFile = (e: any) => {
    setFile(e.target.files[0])
    setErrors({})
  }

  const handleUploadFile = () => {
    setLoading(true)
    api
      .uploadFile({upload_file: file, tipe: typeUpload, prioritas: priority})
      .then((response: any) => {
        setLoading(false)
        const {data} = response
        toast.success(data?.meta?.message)
        handleShowModalUpload(false)
        setShowModal(false)
        setErrors({})
        setFile({})
      })
      .catch((error: any) => {
        setLoading(false)
        const {data, status} = error.response
        setErrors(data?.meta?.error)

        handleApiError(error, navigate)
        toast.error(data?.meta?.message)
      })
  }

  return (
    <Modal show={showModal} centered size='lg'>
      <div className='p-10'>
        <p className='h4 mt-5'>Update File Pendukung</p>
        <p className='mb-5'>upload dokumen</p>

        <label className='border rounded-pill h6 text-center p-4 w-100' style={{cursor: 'pointer'}}>
          <i className='fa fa-paperclip'></i> Upload Dokumen
          <input
            type='file'
            id='input-file-avatar'
            style={{display: 'none'}}
            name='GeneralImages'
            onChange={handleChangeFile}
          />
        </label>
        <p
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '100%',
          }}
        >
          {file?.name}
        </p>

        {errors?.upload_file ? <p className='text-danger mt-1'>{errors?.upload_file}</p> : null}

        <button
          className='btn btn-primary btn-sm w-100 mt-6'
          style={{background: ' var(--Primary-L-500, #F95E2F)'}}
          onClick={handleUploadFile}
          disabled={loading}
        >
          {loading ? 'Loading...' : 'Simpan'}
        </button>

        <button
          className='btn btn-sm w-100 mt-3 text-primary'
          style={{border: '1px solid var(--Primary-L-500, #F95E2F)'}}
          onClick={handleCloseModal}
          disabled={loading}
        >
          Batal
        </button>
      </div>
    </Modal>
  )
}

const UploadModal: FC<Props> = ({showModalUpload, handleShowModalUpload, typeUpload, priority}) => {
  return (
    <UploadContent
      showModalUpload={showModalUpload}
      handleShowModalUpload={handleShowModalUpload}
      typeUpload={typeUpload}
      priority={priority}
    />
  )
}

export default UploadModal
